import React from "react";
import { useMediaQuery } from "@uidotdev/usehooks";
import NavBarEN from "./NavBarEN";
import NavBarMobileEN from "./NavBarMobileEN";
import FooterEN from "./FooterEN";
import FormEN from "./FormEN";
import imageSuse from "../catalog/ikonica-suse-2025.png";
import imageGrad from "../catalog/grad_ikonica.png";
import imageToplotniTalasi from "../catalog/toplotni-talasi-ikonica2.jpg";
import imageLedenaKisa from "../catalog/ledena-kisa-ikonica.png";

export default function KatalogEN() {
  const isSmallDevice = useMediaQuery("only screen and (max-width: 768px)");
  const allDevices = useMediaQuery("only screen and (min-width: 769px)");

  return (
    <>
      {allDevices && <NavBarEN />}
      {isSmallDevice && <NavBarMobileEN />}
      <div
        style={{
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
        className="container mx-auto text-center min-h-screen max-w-screen-xl pt-6"
      >
        <div className="flex justify-start items-center">
          <h1 className="text-3xl lg:text-4xl text-blue-400 font-semibold mb-4 pb-2 text-center lg:text-left">
            CATALOG OF WEATHER AND CLIMATE EXTREMES IN SERBIA
          </h1>
        </div>
        <div className="mx-auto text-left">
          <hr />
          <p className="px-5 sm:px-0 pt-5 sm:pt-0 text-justify sm:text-left md:pt-4">
            Introductory Note: The EXTREMES catalog will be regularly updated
            during the project implementation period, so relatively frequent
            changes and additions to the content, presented information, images,
            and graphics are possible. In this regard, we encourage all users of
            the catalog to periodically check for updates to ensure access to
            the latest information.
          </p>
          <br />
        </div>

        <div className="wrapper max-w-screen-xl mx-auto">
          <a href="/en/dry-spells">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>DROUGHTS</h2>
                <p>
                  Observed data and <br />
                  future projections <br />
                  and trends
                </p>
              </div>
              <img src={imageSuse} alt="Droughts" />
            </div>
          </a>

          <a href="/en/hail">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>HAILSTORMS</h2>
                <p>
                  Observed data, <br />
                  trends, <br />
                  climatology, and <br />
                  indices
                </p>
              </div>
              <img src={imageGrad} alt="Hailstorms" />
            </div>
          </a>

          <a href="/heat-waves">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>HEAT WAVES</h2>
                <p>
                  Observed data and <br />
                  future projections <br />
                  and trends
                </p>
              </div>
              <img src={imageToplotniTalasi} alt="Heat waves" />
            </div>
          </a>

          <a href="/en/freezing-rain">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>FREEZING RAIN</h2>
                <p>
                  Observed data, trends, duration, vertical profiles of the
                  atmosphere
                </p>
              </div>
              <img src={imageLedenaKisa} alt="Freezing rain" />
            </div>
          </a>
        </div>
      </div>
      <FormEN />
      <FooterEN />
    </>
  );
}
